import AppPage from "layouts/AppPage";
import { useParams } from "react-router";
import { useMeetingTemplateDetailQuery } from "features/Resources/MeetingTemplate/hooks";
import MeetingTemplateForm from "features/Resources/MeetingTemplate/Layout/MeetingTemplateForm";
import { usePrebuiltMeetingTemplateDetailQuery } from "features/Prebuilt/PrebuiltSharedTemplate/hooks";
import PrebuiltMeetingTemplateDisplay from "features/Resources/MeetingTemplate/Layout/PrebuiltMeetingTemplateDisplay";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { truncateEnd } from "helpers/string";

export default function MeetingTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data = {}, isLoading } = useMeetingTemplateDetailQuery(id, {
    enabled: !!id && id !== "new",
  });

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Meeting Templates", toUrl: PEOPLE_TEAM_ROUTES.meetingTemplates.index },
          { name: id === "new" ? "New" : `${truncateEnd(data?.name)}` },
        ]}
      />
      {(data || id === "new") && (
        <MeetingTemplateForm id={id} data={data} />
      )}
    </AppPage>
  );
}

export function PrebuiltMeetingTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data, isLoading } = usePrebuiltMeetingTemplateDetailQuery(id!);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      {data && (
        <PrebuiltMeetingTemplateDisplay prebuiltMeetingTemplate={data} />
      )}
    </AppPage>
  );
}
